import { getDomainConfigValue } from "../../utils/domain-config";

function srtToVtt(srt) {
  let vtt = "WEBVTT FILE\n\n";
  const subs = srt.split("\n\n");

  subs.forEach((sub) => {
    const lines = sub.split("\n");
    if (lines.length >= 3) {
      const time = lines[1].replaceAll(",", ".");
      const text = lines.slice(2).join("\n");
      vtt += `${time}\n${text}\n\n`;
    }
  });

  return vtt;
}

export async function addCaptionsToVideo(videoElement, category, id) {
  const language = getDomainConfigValue("videoSubtitlesLanguage");
  if (!language) {
    return;
  }

  try {
    const srtRequest = await fetch(
      `https://blobs-xr-academy-fxhygyhwcddyerbg.z03.azurefd.net/subtitles/${category}/${language}/${id}.srt`
    );
    const srt = await srtRequest.text();
    const vtt = srtToVtt(srt);
    const blob = new Blob([vtt], { type: "text/vtt" });
    const url = URL.createObjectURL(blob);

    const track = document.createElement("track");
    track.setAttribute("default", "true");
    track.setAttribute("kind", "captions");
    track.setAttribute("src", url);
    track.setAttribute("srclang", language);
    videoElement.appendChild(track);
  } catch (e) {
    console.error(
      `Failed to load subtitles for video ${id} in category ${category} and language ${language}`
    );
    console.error(e);
  }
}
